module.exports = __webpack_public_path__ + "static/media/WM.3ec657a8.png";